import { gql } from "@apollo/client";

export const setDiscoverability = gql`
    mutation setDiscoverability($lensId: ID!, $discoverability: DiscoverabilityInput!) {
        setDiscoverability(input: { lensId: $lensId, discoverability: $discoverability }) {
            lens {
                id
                discoverability {
                    tagsList
                    description
                    locationsList
                    daysTimesHolidaysList
                }
            }
        }
    }
`;
